import { useNavigate } from "react-router-dom";

export default function Footer() {
  const navigate = useNavigate();

  return (
    <footer className="bg-gradient-to-br from-rose-600 via-pink-600 to-rose-700 text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Logo & Description */}
          <div className="lg:col-span-1">
            <button
              onClick={() => navigate("/")}
              className="flex flex-col items-start mb-4 cursor-pointer group"
            >
              <div className="flex items-center space-x-2 mb-2">
                <div className="relative">
                  <div className="text-3xl font-black text-white">
                    OUTLETLIO
                  </div>
                  <div className="absolute -bottom-1 left-0 right-0 h-1 bg-white rounded-full transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300"></div>
                </div>
              </div>
              <span className="text-sm font-medium text-white/90">
                Senin Outletin
              </span>
            </button>
            <p className="text-white/80 text-sm leading-relaxed">
              En iyi fırsatları kaçırmayın. Binlerce ürün arasından size özel
              indirimler.
            </p>
          </div>

          <div>
            <h3 className="text-white font-bold mb-4 text-sm">Kategoriler</h3>
            <ul className="space-y-3">
              <li>
                <a
                  href="/category/ayakkabi"
                  className="text-sm hover:text-rose-500 transition-colors cursor-pointer"
                >
                  Ayakkabı
                </a>
              </li>
              <li>
                <a
                  href="/category/giyim"
                  className="text-sm hover:text-rose-500 transition-colors cursor-pointer"
                >
                  Giyim
                </a>
              </li>
              <li>
                <a
                  href="/category/elektronik"
                  className="text-sm hover:text-rose-500 transition-colors cursor-pointer"
                >
                  Elektronik
                </a>
              </li>
              <li>
                <a
                  href="/category/kozmetik"
                  className="text-sm hover:text-rose-500 transition-colors cursor-pointer"
                >
                  Kozmetik
                </a>
              </li>
              <li>
                <a
                  href="/category/aksesuar"
                  className="text-sm hover:text-rose-500 transition-colors cursor-pointer"
                >
                  Aksesuar
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-bold mb-4 text-sm">Hızlı Linkler</h3>
            <ul className="space-y-3">
              <li>
                <a
                  href="/about"
                  className="text-sm hover:text-rose-500 transition-colors cursor-pointer"
                >
                  Hakkımızda
                </a>
              </li>
              <li>
                <a
                  href="/how-it-works"
                  className="text-sm hover:text-rose-500 transition-colors cursor-pointer"
                >
                  Nasıl Çalışır
                </a>
              </li>
              <li>
                <a
                  href="/brands"
                  className="text-sm hover:text-rose-500 transition-colors cursor-pointer"
                >
                  Markalar
                </a>
              </li>
              <li>
                <a
                  href="/blog"
                  className="text-sm hover:text-rose-500 transition-colors cursor-pointer"
                >
                  Blog
                </a>
              </li>
              <li>
                <a
                  href="/contact"
                  className="text-sm hover:text-rose-500 transition-colors cursor-pointer"
                >
                  İletişim
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-bold mb-4 text-sm">Destek</h3>
            <ul className="space-y-3">
              <li>
                <a
                  href="/faq"
                  className="text-sm hover:text-rose-500 transition-colors cursor-pointer"
                >
                  Sıkça Sorulan Sorular
                </a>
              </li>
              <li>
                <a
                  href="/privacy"
                  className="text-sm hover:text-rose-500 transition-colors cursor-pointer"
                >
                  Gizlilik Politikası
                </a>
              </li>
              <li>
                <a
                  href="/terms"
                  className="text-sm hover:text-rose-500 transition-colors cursor-pointer"
                >
                  Kullanım Koşulları
                </a>
              </li>
              <li>
                <a
                  href="/affiliate"
                  className="text-sm hover:text-rose-500 transition-colors cursor-pointer"
                >
                  Affiliate Program
                </a>
              </li>
              <li>
                <a
                  href="/contact"
                  className="text-sm hover:text-rose-500 transition-colors cursor-pointer"
                >
                  Bize Ulaşın
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/20">
          <div className="flex flex-col md:flex-row items-center justify-center gap-4">
            <p className="text-sm text-white/70">
              © 2024 Outletlio. Tüm hakları saklıdır.
            </p>
            <span className="hidden md:block text-white/30">•</span>
            <div className="flex items-center space-x-2">
              <span className="text-sm text-white/70">İletişim:</span>
              <a
                href="mailto:info@outletlio.com"
                className="text-sm text-white hover:text-rose-300 transition-colors cursor-pointer"
              >
                info@outletlio.com
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
